import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6d794cd4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6d794cd4&prod&scoped=true&lang=less"
import style1 from "./index.vue?vue&type=style&index=1&id=6d794cd4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d794cd4",
  null
  
)

export default component.exports